/**
 * Created by maximus on 03.05.17.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

require('./Logo.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    LogoView: {
        displayName: 'LogoView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Header/Logo/default/LogoView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var LogoView = _wrapComponent('LogoView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(LogoView, _Component);

    function LogoView() {
        (0, _classCallCheck3.default)(this, LogoView);
        return (0, _possibleConstructorReturn3.default)(this, (LogoView.__proto__ || (0, _getPrototypeOf2.default)(LogoView)).apply(this, arguments));
    }

    (0, _createClass3.default)(LogoView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                imgClassName = _props.imgClassName,
                logo = _props.logo,
                onClick = _props.onClick,
                lang = _props.lang;


            var logoTitle = lang['store.header.your_logo'];
            var goToMain = lang['store.common.go_to_main'];

            return _react3.default.createElement(
                _reactRouter.Link,
                { to: '/', onClick: onClick },
                logo ? _react3.default.createElement('img', { className: imgClassName, src: logo, alt: goToMain, title: goToMain }) : _react3.default.createElement(
                    'div',
                    { className: 'logo ' + imgClassName, title: goToMain },
                    logoTitle
                )
            );
        }
    }]);
    return LogoView;
}(_react2.Component), _class.propTypes = {
    logo: _react2.PropTypes.string,
    onClick: _react2.PropTypes.func,
    imgClassName: _react2.PropTypes.string,
    lang: _react2.PropTypes.object
}, _temp));

exports.default = LogoView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Logo/default/LogoView.jsx
// module id = 1676
// module chunks = 0